export default __webpack_public_path__ + "static/media/success.d23e9ac6.svg";